import React, { Component } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Redirect } from 'react-router-dom';
import { AppTheme } from '../styles/AppTheme';
import { CommonStyles } from '../styles/Styles';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import { AppHelper } from '../helpers/AppHelper';
import { EmptyMsgView } from '../components/EmptyMsgView';

export class ProductLegacy extends Component {
  constructor(props) {
    super(props)
    this.legacyId = this.props.match.params.legacyId
    this.state = {
      fetchState: ApiHelper.State.LOADING,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    this.fetchItems()
  }

  fetchItems() {
    this.setState({ fetchState: ApiHelper.State.LOADING })

    const options = {
      method: 'GET',
      authWithKey: true,
      endPoint: ApiHelper.makeUrlPath(['miscs', 'products'], { legacyId: this.legacyId })
    };

    ApiHelper.call(options, (err, results) => {
      if (err) {
        this.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: Helper.getErrorMsg(err)
        })
        return
      }

      this.setState({
        fetchState: ApiHelper.State.READY,
        item: results
      })
    })
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView()
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return <Redirect to={'/'} />
    } else {
      return <Redirect to={'/products/' + this.state.item.slug} />
    }
  }
}

const Styles = StyleSheet.create({
})


// WEBPACK FOOTER //
// ./src/screens/ProductLegacy.js